import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { keyForCodeForSection, sectionLockStatus } from '@/pages/timeline/sections/timeline/timelineSections/constants'
import ExamView from './view';


export default function Exam(props: any) {
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const timelineAccordionStatus = useSelector((state: RootState) => state.timelineAccordionStatusReducer.timelineAccordionStatus);
    const [isSectionLocked, setIsSectionLocked] = useState(false)

    useEffect(() => {
        handleIsSectionLocked()
    }, [timelineAccordionStatus])

    const handleIsSectionLocked = () => {
        if (timelineAccordionStatus[keyForCodeForSection.exam] === sectionLockStatus.locked) {
            setIsSectionLocked(true)
        }
    }

    return (
        <>
            <ExamView
                isSectionLocked={isSectionLocked}
                timelineDetails={timelineDetails}
            />
        </>
    );
};


